// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Main--next-sr-only--3GYLO6Y","pageContainer":"Main--pageContainer--2h3FNtq"};